import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../colorVars';
import { observer } from 'mobx-react-lite';
import { useWebsocketStore } from '../../../../../../stores/websocketStore/websocketProvider';
import ApplyRounding from '../../../../../../utils/math/ApplyRounding';
import { TopRowBox } from '../topRows/topRowBox/TopRowBox';
import {determineTradeTypes} from "../quickTradeModule/determineTradeTypes"

const QtyDisplay = observer(({ tradePlanId }) => {
  const { tradePlanStore  } = useWebsocketStore();
  const tradePlan = tradePlanStore.tradePlans[tradePlanId];
  const openOrderType = determineTradeTypes(tradePlan)[0]?.val; //tradePlan.goLong ? 'BTO' : 'STO';
  const positionId = tradePlanStore.tradePlans[tradePlanId].positionId;
  const origQuantity = (tradePlanStore.positions.tradeUnafraid[positionId]?.entryQuantity ?? 0) * (openOrderType === 'STO' ? -1 : 1);
  const curQuantity = (tradePlanStore.positions.tradeUnafraid[positionId]?.quantity ?? 0) * (openOrderType === 'STO' ? -1 : 1);

  // TODO add origQuantity and symbol as a tooltip -- How?
  return (
    <>
      <TopRowBox width="100px" backgroundColor={colors.grey} color={openOrderType === 'STO' ? colors.red : colors.green}>{`${curQuantity}`}</TopRowBox>
    </>
  );
});

QtyDisplay.propTypes = {
  tradePlanId: PropTypes.string,
};

export default QtyDisplay;
